<template>
  <div class="item">
    <div class="item__details">
      <figure class="item__details-image">
        <img :src="productImage" alt="" />
      </figure>
      <div class="item__details-item">
        <a href="#" class="item__details-name">
          <span class="item__details-brand">{{ item.brand }}</span>
          Deva 60 Pack - Women's
        </a>
        <span class="item__details-color">{{ item.color }}</span>
        <span class="item__details-size">{{ item.size }}</span>
        <span class="item__details-sku">#{{ item.sku }}</span>

        <div class="item__details-buttons">
          <button
            :id="`save-for-later-btn-${item.sku}`"
            type="button"
            name=""
            class="btn btn--small"
            @click="$emit('save-for-later', item.id)"
          >
            Save for later
          </button>
          <button
            :id="`remove-btn-${item.sku}`"
            type="button"
            name=""
            class="btn btn--small"
            @click="$emit('remove', item.id)"
          >
            Remove
          </button>
        </div>
      </div>
    </div>
    <div class="item__options">
      <div class="item__options-inner">
        <div class="item__options-row item__options-row--pricing">
          <div class="item__options-quantity">
            <button
              :id="`decrement-${item.sku}`"
              type="button"
              name="button"
              class="btn btn--decrement"
              @click="decrementQuantity"
            >
              <MinusIcon />
            </button>
            <input
              type="number"
              name=""
              pattern="[0-9]*"
              :value="item.quantity"
            />
            <button
              :id="`increment-${item.sku}`"
              type="button"
              name="button"
              class="btn btn--increment"
              @click="incrementQuantity"
            >
              <PlusIcon />
            </button>
          </div>
          <div class="item__options-price">
            <span>${{ formattedPrice }}</span>
          </div>
          <div class="item__options-total">
            <span>{{ totalPrice }}</span>
          </div>
        </div>
        <fieldset>
          <div class="item__options-row">
            <input
              :id="`item-ship-${item.id}`"
              type="radio"
              :name="inputName"
              value=""
              checked
            />
            <label :for="`item-ship-${item.id}`"
              >Ship - Free for orders over $50</label
            >
          </div>

          <div class="item__options-row">
            <input
              :id="`item-pick-up-${item.id}`"
              type="radio"
              :name="inputName"
              value=""
            />
            <label :for="`item-pick-up-${item.id}`"
              >Pick up in store - Free</label
            >
            <a href="#">Find a store near you</a>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import PlusIcon from "../assets/icons/PlusIcon.vue";
import MinusIcon from "../assets/icons/MinusIcon.vue";

export default {
  name: "CartItem",
  components: {
    PlusIcon,
    MinusIcon,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    /*
    Comes up with a unique input name attribute for each item's radio buttons
    */
    inputName() {
      return `name-${this.item.id}`;
    },

    /*
    Provides the image path for the product image
    */
    productImage() {
      // return import `@/assets/${this.item.img}`;
      return require(`@/assets/${this.item.img}`);
    },

    /* Formats the price number so it's padded with zeroes
     */
    formattedPrice() {
      return this.item.price.toFixed(2);
    },

    /* Calculates the total price of the product */
    totalPrice() {
      const total = this.item.price * this.item.quantity;
      return total.toFixed(2);
    },
  },
  methods: {
    /*
    Called when the increment quantity button (#increment-quantity-btn) is clicked
    Emits an event to increase the item quantity by 1
    */
    incrementQuantity() {
      this.$emit("increment-quantity", this.item.id);
    },

    /*
    Called when the decrement quantity button (#decrement-quantity-btn) is clicked
    Emits an event to decrease the item quantity by 1
    */
    decrementQuantity() {
      this.$emit("decrement-quantity", this.item.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/CartItem.scss";
</style>
